import { AppTooltip } from '../../@components'
import { IconSeekers } from 'ui-seeker/core'
import * as React from 'react'
import { getAppUserData } from '../../@utils'


export default function BottomNavLogoutButton() {

    const { username } = getAppUserData()


    return <a className="toolItem" href="/logout">
            <span className="toolIcon">
                <AppTooltip
                    title={`Logout ${username}`}
                    placement="right"
                >
                    <IconSeekers icon="sign-out" iconType="fontAwesome" />
                </AppTooltip>
            </span>
    </a>
}